import { useRouter } from 'next/router';
import { useEffect, useState } from 'react';

export const useLtiUserData = () => {
  const router = useRouter();
  const [ltiUserData, setLtiUserData] = useState<null | string | undefined>(undefined);

  useEffect(() => {
    if (router.isReady) {
      if (typeof router.query.ltiUserData === 'string') {
        setLtiUserData(decodeURIComponent(String(router.query.ltiUserData)));
      } else {
        setLtiUserData(null);
      }
    } else {
      setLtiUserData(undefined);
    }
  }, [router.isReady, router.query]);

  return ltiUserData;
};
